const islandProgression = state => state.islandProgression;

const translation = state => state.translation;

const transcribe = state => state.transcribedText;

const botmsg = state => state.botmsg;

const teachbotGroups = state => state.teachbotGroups;

const grammarGroups = state => state.grammarGroups;

const thematics = state => state.thematics;

const thematicsByLevel = state => state.thematicsByLevel;

const lesson = state => state.lesson;

const getTeachbotLesson = state => state.teachbotLesson;

const catalog = state => state.catalog;

const lessonInfo = state => state.lessonInfo;

const evaluatedLesson = state => state.evaluatedLesson;

const expression = state => state.expression;

const expressions = state => state.expressions;

const expressionsAll = state => state.expressionsAll;

const expressionTags = state => state.expressionTags;

const weeklyLessons = state => state.weeklyLessons;

const currentlyLoadedIsland = state => state.currentlyLoadedIslandWhereUserWas;

const currentlyLoadedIslandLevel = state => state.currentlyLoadedIslandLevel;

const isExpressionFavourited = state => (id) => {
  const storedExpressionFlag = state.favouritedExpressionIds[id];
  if (storedExpressionFlag !== undefined) {
    return storedExpressionFlag;
  }
  return undefined;
};

const getIsLanguageCollision = state => state.languageCollison;

const getSendedLanguageCollisonHeader = state => state.sendedLanguageCollisonHeader;

const getIsClassLanguageCollison = state => state.isClassLanguageCollison;

export default {
  islandProgression,
  thematics,
  thematicsByLevel,
  lesson,
  evaluatedLesson,
  lessonInfo,
  expression,
  expressions,
  expressionsAll,
  expressionTags,
  weeklyLessons,
  currentlyLoadedIsland,
  botmsg,
  catalog,
  translation,
  transcribe,
  teachbotGroups,
  grammarGroups,
  isExpressionFavourited,
  currentlyLoadedIslandLevel,
  getTeachbotLesson,
  getIsLanguageCollision,
  getSendedLanguageCollisonHeader,
  getIsClassLanguageCollison,
};
